const difficulties = [
  { value: 50, label: "🐭 Easy", emoji: "🐭", scoreMultiplier: 1 },
  { value: 100, label: "🦊 Normal", emoji: "🦊", scoreMultiplier: 2 },
  { value: 150, label: "🐘 Hard", emoji: "🐘", scoreMultiplier: 3 },
  { value: 200, label: "🐉 Expert", emoji: "🐉", scoreMultiplier: 5 },
];

export default difficulties